import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FCFCFC",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M39.13 21.74h-3.26c0 6.003-4.867 10.869-10.87 10.869-6.003 0-10.87-4.867-10.87-10.87h-3.26c0 6.467 4.343 11.919 10.272 13.598a3.617 3.617 0 0 0 .377 3.948l3.554-2.848 3.553 2.848a3.618 3.618 0 0 0 .358-3.986c5.864-1.72 10.146-7.14 10.146-13.56Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M16.304 20.652s0 5.435 5.435 5.435l1.087 1.087H25s1.087-3.26 3.26-3.26c0 0 0-2.175 2.175-2.175h3.26s-1.086-4.348 4.348-7.609l-2.173-1.086s-7.61 5.434-13.044 4.348v2.173h-2.174l-1.087-1.087-3.26 2.174Z"
}));
FlagCY.displayName = 'FlagCY';
export default withFlagWrapper(FlagCY);
//# sourceMappingURL=index.js.map